import { useSelector as _useSelector, useDispatch as _useDispatch } from 'react-redux';
import { useLocation as _useLocation } from 'react-router-dom';
import { useNavigate as _useNavigate } from 'react-router-dom';

export function useSelector(...args) {
  return _useSelector(...args);
}

export function useDispatch() {
  return _useDispatch();
}

export function useLocation() {
  return _useLocation();
}

export function useNavigate() {
  return _useNavigate();
}
